export default class {
	idAtaRegistroPreco
	idUnidadeOrganizacional

	constructor(idAtaRegistroPreco, idUnidadeOrganizacional) {
		this.idAtaRegistroPreco = idAtaRegistroPreco
		this.idUnidadeOrganizacional = idUnidadeOrganizacional
	}
}
